import { render, staticRenderFns } from "./OptionTypeAddEditModal.vue?vue&type=template&id=18911106&scoped=true&"
import script from "./OptionTypeAddEditModal.vue?vue&type=script&lang=js&"
export * from "./OptionTypeAddEditModal.vue?vue&type=script&lang=js&"
import style0 from "./OptionTypeAddEditModal.vue?vue&type=style&index=0&id=18911106&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18911106",
  null
  
)

export default component.exports